/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Reviewers_ErrorInputs */



/**
* | output |
* | --- |
* | "Unable to load reviewers. You can still request review without selecting users." |
*
* @param {Iconik_Publish_Reviewers_ErrorInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_reviewers_error = /** @type {((inputs?: Iconik_Publish_Reviewers_ErrorInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Reviewers_ErrorInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
	return /** @type {LocalizedString} */ ("Unable to load reviewers. You can still request review without selecting users.")
});